import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import DoorCheckAdd from './views/DoorCheckAdd.vue'
import DoorCheckView from './views/DoorCheckView.vue'
import DoorCheckSitePlanView from './views/DoorCheckSitePlanView.vue'
import DoorCheckSitePlanAdd from './views/DoorCheckSitePlanAdd.vue'
import DoorCheckDoorAdd from './views/DoorCheckDoorAdd.vue'
import DoorCheckDoorView from './views/DoorCheckDoorView.vue'
import RiskAuditAdd from './views/RiskAuditAdd.vue'
import RiskAuditView from './views/RiskAuditView.vue'
import ExtinguisherReportsList from './views/ExtinguisherReportsList.vue'
import ExtinguisherReportView from './views/ExtinguisherReportView.vue'
import ExtinguisherReportAdd from './views/ExtinguisherReportAdd.vue'
import ExtinguisherView from './views/ExtinguisherView.vue'
import ExtinguisherAdd from './views/ExtinguisherAdd.vue'
import FireStoppingReportsList from './views/FireStoppingReportsList.vue'
import FireStoppingReportView from './views/FireStoppingReportView.vue'
import FireStoppingReportAdd from './views/FireStoppingReportAdd.vue'
import FireStoppingReportSitePlanView from './views/FireStoppingReportSitePlanView.vue'
import FireStoppingReportSitePlanAdd from './views/FireStoppingReportSitePlanAdd.vue'
import FireStoppingReportItemView from './views/FireStoppingReportItemView.vue'
import FireStoppingReportItemAdd from './views/FireStoppingReportItemAdd.vue'
import BaeSystemsReportsList from './views/BaeSystemsReportsList.vue'
import BaeSystemsReportView from './views/BaeSystemsReportView.vue'
import BaeSystemsReportAdd from './views/BaeSystemsReportAdd.vue'
import DoorInstallationReportsList from './views/DoorInstallationReportsList.vue'
import DoorInstallationReportView from './views/DoorInstallationReportView.vue'
import DoorInstallationReportAdd from './views/DoorInstallationReportAdd.vue'
import DoorInstallationReportItemAdd from './views/DoorInstallationReportItemAdd.vue'
import DoorInstallationReportItemView from './views/DoorInstallationReportItemView.vue'
import DoorMaintenanceReportsList from './views/DoorMaintenanceReportsList.vue'
import DoorMaintenanceReportView from './views/DoorMaintenanceReportView.vue'
import DoorMaintenanceReportAdd from './views/DoorMaintenanceReportAdd.vue'
import DoorMaintenanceReportItemAdd from './views/DoorMaintenanceReportItemAdd.vue'
import DoorMaintenanceReportItemView from './views/DoorMaintenanceReportItemView.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/door-checks/add',
            name: 'door-check-add',
            component: DoorCheckAdd,
        },
        {
            path: '/door-checks/edit/:id',
            name: 'door-check-edit',
            component: DoorCheckAdd,
        },
        {
            path: '/door-checks/view/:id',
            name: 'door-check-view',
            component: DoorCheckView
        },
        {
            path: '/door-checks/add-site-plan/:id',
            name: 'door-check-add-site-plan',
            component: DoorCheckSitePlanAdd,
        },
        {
            path: '/door-checks/edit-site-plan/:id',
            name: 'door-check-edit-site-plan',
            component: DoorCheckSitePlanAdd,
        },
        {
            path: '/door-checks/view-site-plan/:id',
            name: 'door-check-view-site-plan',
            component: DoorCheckSitePlanView,
        },
        {
            path: '/door-checks/add-door/:id',
            name: 'door-check-add-door',
            component: DoorCheckDoorAdd
        },
        {
            path: '/door-checks/edit-door/:id',
            name: 'door-check-edit-door',
            component: DoorCheckDoorAdd
        },
        {
            path: '/door-checks/doors/view/:id',
            name: 'door-check-view-door',
            component: DoorCheckDoorView
        },
        {
            path: '/risk-audits/add',
            name: 'risk-audit-add',
            component: RiskAuditAdd,
        },
        {
            path: '/risk-audits/edit/:id',
            name: 'risk-audit-edit',
            component: RiskAuditAdd,
        },
        {
            path: '/risk-audits',
            name: 'risk-audit-view',
            component: RiskAuditView,
        },
        {
            path: '/extinguisher-reports',
            name: 'extinguisher-reports-list',
            component: ExtinguisherReportsList,
        },
        {
            path: '/extinguisher-reports/add',
            name: 'extinguisher-report-add',
            component: ExtinguisherReportAdd,
        },
        {
            path: '/extinguisher-reports/edit/:id',
            name: 'extinguisher-report-edit',
            component: ExtinguisherReportAdd,
        },
        {
            path: '/extinguisher-reports/view/:id',
            name: 'extinguisher-report-view',
            component: ExtinguisherReportView,
        },
        {
            path: '/extinguisher-reports/add-extinguisher/:id',
            name: 'extinguisher-report-add-extinguisher',
            component: ExtinguisherAdd,
        },
        {
            path: '/extinguisher-reports/edit-extinguisher/:id',
            name: 'extinguisher-report-edit-extinguisher',
            component: ExtinguisherAdd,
        },
        {
            path: '/extinguisher-reports/view-extinguisher/:id',
            name: 'extinguisher-report-view-extinguisher',
            component: ExtinguisherView,
        },
        {
            path: '/fire-stopping-reports',
            name: 'fire-stopping-reports-list',
            component: FireStoppingReportsList,
        },
        {
            path: '/fire-stopping-reports/add',
            name: 'fire-stopping-report-add',
            component: FireStoppingReportAdd,
        },
        {
            path: '/fire-stopping-reports/edit/:id',
            name: 'fire-stopping-report-edit',
            component: FireStoppingReportAdd,
        },
        {
            path: '/fire-stopping-reports/view/:id',
            name: 'fire-stopping-report-view',
            component: FireStoppingReportView,
        },
        {
            path: '/fire-stopping-reports/add-site-plan/:id',
            name: 'fire-stopping-report-add-site-plan',
            component: FireStoppingReportSitePlanAdd,
        },
        {
            path: '/fire-stopping-reports/edit-site-plan/:id',
            name: 'fire-stopping-report-edit-site-plan',
            component: FireStoppingReportSitePlanAdd,
        },
        {
            path: '/fire-stopping-reports/view-site-plan/:id',
            name: 'fire-stopping-report-view-site-plan',
            component: FireStoppingReportSitePlanView,
        },
        {
            path: '/fire-stopping-reports/add-item/:id',
            name: 'fire-stopping-report-add-item',
            component: FireStoppingReportItemAdd,
        },
        {
            path: '/fire-stopping-reports/edit-item/:id',
            name: 'fire-stopping-report-edit-item',
            component: FireStoppingReportItemAdd,
        },
        {
            path: '/fire-stopping-reports/view-item/:id',
            name: 'fire-stopping-report-view-item',
            component: FireStoppingReportItemView,
        },
        {
            path: '/bae-systems-reports',
            name: 'bae-systems-reports-list',
            component: BaeSystemsReportsList,
        },
        {
            path: '/bae-systems-reports/add',
            name: 'bae-systems-report-add',
            component: BaeSystemsReportAdd,
        },
        {
            path: '/bae-systems-reports/edit/:id',
            name: 'bae-systems-report-edit',
            component: BaeSystemsReportAdd,
        },
        {
            path: '/bae-systems-reports/view/:id',
            name: 'bae-systems-report-view',
            component: BaeSystemsReportView,
        },
        {
            path: '/door-installation-reports',
            name: 'door-installation-reports-list',
            component: DoorInstallationReportsList,
        },
        {
            path: '/door-installation-reports/view/:id',
            name: 'door-installation-report-view',
            component: DoorInstallationReportView,
        },
        {
            path: '/door-installation-reports/add',
            name: 'door-installation-report-add',
            component: DoorInstallationReportAdd,
        },
        {
            path: '/door-installation-reports/edit/:id',
            name: 'door-installation-report-edit',
            component: DoorInstallationReportAdd,
        },
        {
            path: '/door-installation-reports/add-door/:id',
            name: 'door-installation-report-add-item',
            component: DoorInstallationReportItemAdd,
        },
        {
            path: '/door-installation-reports/edit-door/:id',
            name: 'door-installation-report-edit-item',
            component: DoorInstallationReportItemAdd,
        },
        {
            path: '/door-installation-reports/view-door/:id',
            name: 'door-installation-report-view-item',
            component: DoorInstallationReportItemView,
        },
        {
            path: '/door-maintenance-reports',
            name: 'door-maintenance-reports-list',
            component: DoorMaintenanceReportsList,
        },
        {
            path: '/door-maintenance-reports/view/:id',
            name: 'door-maintenance-report-view',
            component: DoorMaintenanceReportView,
        },
        {
            path: '/door-maintenance-reports/add',
            name: 'door-maintenance-report-add',
            component: DoorMaintenanceReportAdd,
        },
        {
            path: '/door-maintenance-reports/edit/:id',
            name: 'door-maintenance-report-edit',
            component: DoorMaintenanceReportAdd,
        },
        {
            path: '/door-maintenance-reports/add-door/:id',
            name: 'door-maintenance-report-add-item',
            component: DoorMaintenanceReportItemAdd,
        },
        {
            path: '/door-maintenance-reports/edit-door/:id',
            name: 'door-maintenance-report-edit-item',
            component: DoorMaintenanceReportItemAdd,
        },
        {
            path: '/door-maintenance-reports/view-door/:id',
            name: 'door-maintenance-report-view-item',
            component: DoorMaintenanceReportItemView,
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        }
    ],
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});
